module.exports = __webpack_public_path__ + "static/media/playstore.77e9900f.svg";